import type {
  CoreCoachPaymentsRefundsExecuteParams,
  CoreCoachPaymentsRefundsReadParams,
} from '../../types/core/methods';
import type {RefundApiModel} from './types';

import {EntityStore} from '../../utils/entityStore';

export class RefundStore<
  T extends RefundApiModel = RefundApiModel,
> extends EntityStore<T, CoreCoachPaymentsRefundsReadParams> {
  execute = this._createMethod<CoreCoachPaymentsRefundsExecuteParams>({
    method: 'coach.payments.refunds.execute',
  });
  executeBatch = this._createBatchMethod<CoreCoachPaymentsRefundsExecuteParams>(
    {
      method: 'coach.payments.refunds.execute',
    },
  );
}

export const refundStore = new RefundStore('refund', {
  fetch: 'coach.payments.refunds.read',
});
